<app-header-inner></app-header-inner>
<app-breadcrumbs></app-breadcrumbs>
<app-content></app-content>
<section class="partner-one partner-one--services text-center">
    <app-partners></app-partners>
</section>
<section class="features-one features-one--features-five clearfix">
    <app-cta></app-cta>
</section>
<app-footer-inner></app-footer-inner>